module.exports = __webpack_public_path__ + "img/portrait-006.939acd65.jpg";